import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface ProcessingStatusStore {
    openModal: boolean;
    focusedActivityId: string;
    setOpenModal: (openModal: boolean) => void;
    setFocusedActivityId: (focusedId: string) => void;
}

export const useProcessingStatusStore = create<ProcessingStatusStore>()(
    immer((set) => ({
        openModal: false,
        focusedActivityId: '',
        setOpenModal: (openModal: boolean) =>
            set((state: { openModal: boolean }) => {
                state.openModal = openModal;
            }),
        setFocusedActivityId: (focusedActivityId: string) =>
            set((state: { focusedActivityId: string }) => {
                state.focusedActivityId = focusedActivityId;
            }),
    })),
);
